module.exports = __webpack_public_path__ + "assets/send_trigger.326a0ab8f5d630249568810f8f6930cc.svg";